export interface OrderTotal {
  raw: number;
  formatted: string;
}

export const orderTotalFromResponse = (responseData: any): OrderTotal => ({
  raw: responseData.raw,
  formatted: responseData.formatted,
});
